"use client";

import { Button } from "@/components/ui/button";
import Image from "next/image";
import Link from "next/link";
import { useTranslations } from 'next-intl';

export default function NotFound() {
  const t = useTranslations('Errors');
  
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background px-4">
      <div className="flex flex-col items-center max-w-md text-center space-y-8">
        <div className="flex flex-col items-center space-y-4">
          <Image
            src="/logo-full.svg"
            alt="RAJO TRANSPORTES"
            width={200}
            height={200}
            priority
            className="mb-6"
          />
          <h1 className="text-6xl font-bold text-primary">404</h1>
          <h2 className="text-2xl font-semibold text-foreground">{t('pageNotFound')}</h2>
        </div>
        
        <p className="text-muted-foreground">
          {t('pageNotFoundDescription')}
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <Button asChild variant="default" size="lg" className="w-full sm:w-auto">
            <Link href="/">
              {t('backToHome')}
            </Link>
          </Button>
          <Button 
            asChild 
            variant="outline" 
            size="lg" 
            className="w-full sm:w-auto"
          >
            <Link href="#" onClick={(e) => {
              e.preventDefault();
              window.history.back();
            }}>
              {t('goBack')}
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}